import React from 'react';
import classnames from 'classnames';

import Button from '@wix/da-shared-react/pkg/Button';

import s from './EmptyState.scss';

export interface Props {
  className?: string;
  titleClassName?: string;
  subtitleClassName?: string;
  title?: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  view?: 'large' | 'small' | 'wide';
  withButton?: boolean;
  buttonLabel?: string;
  onButtonClick?: () => void;
  customButton?: React.ReactNode;
}
export class EmptyState extends React.Component<Props> {
  render() {
    const {
      className,
      titleClassName,
      subtitleClassName,
      view = 'large',
      title,
      subtitle,
      withButton,
      buttonLabel,
      customButton,
      onButtonClick,
    } = this.props;

    return (
      <div
        className={classnames(
          s['root'],
          s[view],
          withButton && s['with-button'],
          className
        )}
      >
        <div className={s['title-wrapper']}>
          <div className={classnames(s['title'], titleClassName)}>{title}</div>
          <div className={classnames(s['subtitle'], subtitleClassName)}>
            {subtitle}
          </div>
          {withButton && onButtonClick && (
            <Button
              view="b16-undisciplined-designers"
              onClick={onButtonClick}
              className={s['button']}
            >
              {buttonLabel}
            </Button>
          )}
          {customButton}
        </div>
      </div>
    );
  }
}

export default EmptyState;
